import axios from 'axios';

import { API_URL } from '../constants';


export const API = axios.create({
  withCredentials: true,
  baseURL: API_URL
})
